export default __webpack_public_path__ + "static/media/img-nft-v3.8d126f16.png";